<template>
  <div style="border: 1px solid #999" class="pa-2">
    <div class="v-label theme--light pb-2">{{ title }}</div>

    <v-chip
      label
      close
      class="mr-2 mt-2"
      v-for="(item, index) in value"
      :key="index"
      @click="edit(item)"
      @click:close="remove(index)"
      >{{ item.name }} = {{ item.value }}</v-chip
    >
    <v-chip
      color="primary"
      title="Add Column"
      @click="add"
      :disabled="!table"
      class="mt-2"
    >
      <v-icon>mdi-plus</v-icon>
    </v-chip>

    <v-dialog v-model="dialog" width="400" scrollable>
      <v-card>
        <v-card-title>{{ dialogTitle }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <ServerFieldPicker
                  title="Column Name"
                  :table="table"
                  v-model="dataName"
                  @type-change="typeChange"
                />
              </v-col>
              <v-col cols="12">
                <ServerValuePicker
                  v-model="dataValue"
                  title="Value"
                  :type="dataValueType"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="save" :disabled="!dataName"
            >OK</v-btn
          >
          <v-btn color="error" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ServerFieldPicker from "./ServerFieldPicker.vue";
import ServerValuePicker from "./ServerValuePicker.vue";

export default {
  name: "ServerFieldValueListEditor",

  components: { ServerValuePicker, ServerFieldPicker },

  props: ["title", "value", "table"],

  data() {
    return {
      dialog: false,
      dataName: null,
      dataValue: null,
      dataValueType: "text",
      items: [],
      dialogTitle: "",
      editingItem: null,
    };
  },

  watch: {
    value(v) {
      if (v) this.items = v;
    },
  },

  methods: {
    add() {
      this.dialogTitle = "Add";
      this.dataName = null;
      this.dataValue = null;
      this.dataValueType = "text";
      this.dialog = true;
      this.editingItem = null;
    },
    edit(item) {
      this.editingItem = item;
      this.dialogTitle = "Edit";
      this.dataName = item.name;
      this.dataValue = item.value;
      this.dataValueType = item.valueType;
      this.dialog = true;
    },
    save() {
      if (this.editingItem) {
        this.editingItem.name = this.dataName;
        this.editingItem.value = this.dataValue;
        this.editingItem.valueType = this.dataValueType;
      } else {
        this.items.push({
          name: this.dataName,
          value: this.dataValue,
          valueType: this.dataValueType,
        });
      }

      this.dialog = false;
      this.$emit("input", this.items);
    },
    typeChange(t) {
      this.dataValue = null;
      this.dataValueType = t;
    },
    remove(index) {
      this.items.splice(index, 1);
      this.$emit("input", this.items);
    },
  },
};
</script>
